import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import Datatables from "components/Datatables/datatable";
import { get } from 'helpers/api_helper';

const Pdfinvoices = () => {
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    /**
     * Get All Rows
     * @param {row_id} ID 
     * @method {get} GET 
     */
    const getData = async() => {
        setIsLoading(true)

        const { success, items } = await get(`/api/backup/invoices`);
        if(success){
            setDataRows(items)
            setIsLoading(false)
        }
    }
    
    useEffect(() => {
        getData();
    },[])


    // table Column Data
    let datatableData = [
        {
            dataField: 'id',
            text: '#',
            formatter: (cell, row, index) => index+1
        }, {
            dataField: 'created_at',
            text: 'Backup Time'
        }, {
            dataField: 'file_name',
            text: 'File'
        }, {
            dataField: 'size',
            text: 'File Size'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                    <a 
                        href={row.download_link} 
                        className="btn btn-outline-primary btn-sm" 
                        title="Download"
                        target="blank"
                        download
                    >
                        <i className="fas fa-download" />
                    </a>
                </>
        }
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Dashboard | Bulk Invoices</title></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Reports" breadcrumbItem={"Bulk Invoices"} />
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables 
                                        isSearch={false}
                                        columns = {datatableData}
                                        is_remote={false}
                                        csv={false}
                                        showTableOnly={true}
                                        rowsLength = {dataRows?.length || 0}
                                        rows = {dataRows || []}
                                        keyField={'file_name'}
                                        title = "Genrated Bulk Invoices"
                                        loading={isLoading}
                                        isAdd = {false}
                                        isTableHead = {true}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Pdfinvoices
